import { AlertIcon } from '@wonderschool/common-base-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ShowErrors = ({ errors = {}, content = '', icon = 'cancel', header, hideHeader = false }) => {
  const { t } = useTranslation();
  const headerLocal = !hideHeader ? header || t('Something went wrong!') : null;

  if (Object.keys(errors ?? {}).length) {
    return (
      <div
        className="flex w-full flex-col gap-2 rounded-md bg-red-50 p-4 ring-1 ring-red-500"
        data-testid="error-message"
      >
        <div className="flex flex-row items-center gap-2">
          <AlertIcon className="size-5 text-red-500" />
          <span className="text-md font-medium text-red-500">{headerLocal}</span>
        </div>
        <div className="flex flex-col gap-1 rounded-md bg-red-100 px-4 py-3">
          {Object.keys(errors).map((errorKey) => (
            <span key={errorKey} className="text-sm text-red-500">
              {errors[errorKey]}
              <br />
            </span>
          ))}
        </div>
      </div>
    );
  }
  if (content) {
    return (
      <div
        className="flex w-full flex-col gap-2 rounded-md bg-red-50 p-4 ring-1 ring-red-500"
        data-testid="error-message"
      >
        <div className="flex flex-row items-center gap-2">
          <AlertIcon className="size-5 text-red-500" />
          <span className="text-md font-medium text-red-500">{headerLocal}</span>
        </div>
        <div className="flex flex-col gap-1 rounded-md bg-red-100 px-4 py-3">
          <span className="text-sm text-red-500">{content}</span>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

ShowErrors.propTypes = {
  errors: PropTypes.object,
  icon: PropTypes.string,
  header: PropTypes.string,
};

export default ShowErrors;
